type ToastType = 'success' | 'error' | 'info';

class Toast {
  private container: HTMLDivElement | null = null;

  private createContainer() {
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.className = 'fixed top-4 right-4 z-50 space-y-2';
      document.body.appendChild(this.container);
    }
    return this.container;
  }

  private show(message: string, type: ToastType) {
    const container = this.createContainer();
    
    const toast = document.createElement('div');
    const duration = type === 'success' ? 10000 : 5000; // 10 seconds for success, 5 for others
    toast.className = `
      p-4 rounded-lg shadow-lg transform transition-all duration-300 max-w-sm
      ${type === 'error' ? 'bg-red-500 text-white' : 
        type === 'success' ? 'bg-green-500 text-white' : 
        'bg-blue-500 text-white'}
    `;
    
    toast.textContent = message;
    
    // Add to container with animation
    toast.style.opacity = '0';
    container.appendChild(toast);
    
    // Trigger animation
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
    });
    
    // Remove after delay
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => {
        container.removeChild(toast);
        if (container.childNodes.length === 0) {
          document.body.removeChild(container);
          this.container = null;
        }
      }, 300);
    }, duration);
  }

  success(message: string) {
    this.show(message, 'success');
  }

  error(message: string) {
    this.show(message, 'error');
  }

  info(message: string) {
    this.show(message, 'info');
  }
}

export const toast = new Toast();